import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useDispatchDirectives = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useDispatchDirectivesQuery = (filters) =>
    useQuery({
      queryKey: ['getDispatchDirectivesQuery', filters],
      queryFn: (cancelToken) => api.post('dispatch_directive/overview', { filter: filters }, null, cancelToken),
    })

  return { useDispatchDirectivesQuery }
}
